// extracted by mini-css-extract-plugin
export default {"content":"content_content__H-UBC","default":"content_default__b+2Yd"};